<template>
    <div :class="{'row': !removeRowClass}">
        <div class="form-busca">
            <div class="title icon hideshow" :style="cor ? 'background-color: ' + cor  : ''">
                <i class="icon-lupa"></i>
                Busca
            </div>
            <div class="title icon hideshow-mobile" :style="cor ? 'background-color: ' + cor : ''">
                <i class="icon-lupa"></i>
                Busca
            </div>
            <div class="clear"></div>

            <div class="campos content" :style="cor ? 'background-color: ' + cor : ''">
                <div v-for="field in filtros" :class="field.class">
                    <div class="relative-form">
                        <label :for="field.name">{{field.label}}:</label>
                        <template v-if="field.type === 'text'">
                            <label for="input_fd"></label>
                            <input id="input_fd" :type="field.type" :name="field.name" v-model="field.value">
                        </template>
                         <template v-if="field.type === 'select'">
                             <label for="select_fd"></label>
                            <select id="select_fd" :name="field.name" v-model="field.value">
                                <option value="" :selected="!field.value ? 'selected' : ''">Selecione</option>
                                <template v-if="field.hasOwnProperty('option')">
                                    <option v-for="option in selects[field.name]" :value="option[field.option.value]">{{option[field.option.text]}}</option>
                                </template>
                                <template v-if="field.hasOwnProperty('data')">
                                     <option v-for="option in field.data" :value="option.value">{{option.text}}</option>
                                </template>
                            </select>
                        </template>
                        <template v-if="field.type === 'date'">
                            <flat-pickr v-model="field.value" :config="(field.flatConfig? field.flatConfig : flatConfig)"></flat-pickr>
                             <i class="icon-calendar"></i>
                        </template> 
                        <template v-if="field.type === 'autocomplete'">
                            <c-autocomplete
                                    :url="field.url"
                                    :options="field.option"
                                    classe="input-field-post"
                                    :manipulate="field.manipulate"
                                    :name="field.name"
                                    :ref="field.name">
                            </c-autocomplete>
                        </template>
                        <template v-if="field.type === 'format'">
                            <div class="format-filters-container">
                                <div class="format-filter-options-container">
                                    <input type="hidden" :name="field.name" v-model="field.value">
                                    <div class="square-container" @click="toggleFormatFilter(field.name, 'square')">
                                        <div :class="field.value && field.value == 'square'? 'filter square filter-selected' : 'filter square'"></div>
                                        <span>Quadrado</span>
                                    </div>
                                    <div class="rectangle-container" @click="toggleFormatFilter(field.name, 'rectangle')">
                                        <div :class="field.value && field.value == 'rectangle'? 'filter rectangle filter-selected' : 'filter rectangle'"></div>
                                        <span>Retângulo</span>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
                <div class="column-1">
                    
                    <button class="btn-enviar" :style="buttonCollor ? 'background-color:' + buttonCollor : ''" @click="emit">
                        <i class="icon-lupa"></i>
                        Buscar
                    </button>
                </div>
                <div class="column-1">
                    <button class="btn-enviar" style="background-color:#e6a906;" @click="clear">
                        <i class="icon-delete"></i>
                        Limpar
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { Portuguese } from 'flatpickr/dist/l10n/pt.js';
    import formatMixin from '../../mixins/formatMixin';
    import moment from 'moment'

    export default {
        mixins: [formatMixin],
        props:{
            fieldsProp: Array,
            cor: String,
            emitir: {
                type: Boolean,
                default: false
            },
          removeRowClass: {
            type: Boolean,
            default: false
          }
        },
        data() {
            const vue = this

          return {
                filtros: [],
                selects: [],
                flatConfig: {locale: Portuguese, dateFormat: 'd/m/Y'},
                buttonCollor: this.cor
          }
        },
        computed: {
            ...mapGetters({hasRole: 'roles/hasRole'})
        },
        methods: {
            toggleFormatFilter(filterName, format) {
                this.filtros = this.filtros.map(field => {
                    if (field.name === filterName) {
                        if (field.value && field.value === format) {
                            field.value = ''
                        } else {
                            field.value = format
                        }
                    }

                    return field
                })
            },
            emit() {
                let scope   = this;
                let filtros = this.filtros.map(function(data) {

                    if (data.type === 'autocomplete')
                    {
                        if(typeof(scope.$refs[data.name]) != 'undefined') {
                             if(scope.$refs[data.name][0].options.useValue && scope.$refs[data.name][0].options.useValue === true){
                                return {[data.name]: scope.$refs[data.name][0].selecao ? scope.$refs[data.name][0].selecao[scope.$refs[data.name][0].options.value] : null};
                             }else{
                                 return {[data.name]: scope.$refs[data.name][0].selecao ? scope.$refs[data.name][0].selecao.id : null};
                             }
                        }
                    }

                    return {[data.name]: data.value};
                });
                this.$emit('changeFiltros', filtros);
            },
            clear() {
                let scope         = this;
                let dateFlatClear = false;
                this.filtros.map(function(data) {
                    $('input').val('');
                    if(data.type === 'select'){
                        $('select').val('');
                    }
                    if (data.type === 'autocomplete') {
                        scope.$refs[data.name][0].selecao = [];
                        scope.$refs[data.name][0].placeholderAt = '';
                    }
                    // Adicionado somente se tiver a flag para não ser necessário alterar nesse primeiro
                    // momento em todos os lugares onde o c-busca é utilizado
                    if (data.type === 'date' && data.flatClear && data.flatConfig) {
                        dateFlatClear    = true
                        scope.flatConfig = data.flatConfig
                    }
                    data.value = '';
                });
                if (dateFlatClear) {
                    let flatpickrFields = flatpickr(".flatpickr-input", this.flatConfig)
                    if(flatpickrFields instanceof Array) {
                        flatpickr(".flatpickr-input", this.flatConfig).forEach(i => {
                            i.clear()
                            i.jumpToDate()
                        })
                    } else {
                        flatpickrFields.clear()
                        flatpickrFields.jumpToDate()
                    }
                }
                if (this.emitir)
                {
                    this.emit();
                }
            },

            flatPickr() {
                let elements = Array.prototype.slice.call(document.getElementsByClassName('flatpickr-weekdaycontainer'));

                Array.prototype.forEach.call(elements, function(el) {
                    let fragment = document.createDocumentFragment();

                    while(el.firstChild) {
                        fragment.appendChild(el.firstChild);
                    }
                    el.parentNode.replaceChild(fragment, el);
                });
            }
        },
        mounted: async function() {

            this.filtros      = this.fieldsProp;
            if (this.cor)
            {
                this.buttonCollor = this.shadeColor(this.cor, -20);
            }
            this.filtros.map(async (field, index) => {
                if (field.hasOwnProperty('permissao') && !this.hasRole(field.permissao))
                {
                    this.filtros.splice(index, 1);
                }
                else if (field.url && field.type !== 'autocomplete')
                {
                    const url = field.completeUrl? field.url : _ROOT_PATH + field.url

                    let sel = await this.axios.get(url);
                    this.selects[field.name] = await sel.data.data;
                }

                this.$forceUpdate();
            });
            this.emit();
        },
        updated() {
            this.flatPickr();
        }
    };
</script>